import styled from 'styled-components';

interface Props {
   flexDirection?: 'row' | 'column';
   justifyContent: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
   flexWrap?: 'wrap' | 'nowrap';
   margin?: string;
   alignItems?: 'center' | 'flex-start' | 'flex-end';
   width?: string;
}

const FlexWrapper = styled.div<Props>`
   display: flex;
   flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
   justify-content: ${({ justifyContent }) => justifyContent};
   flex-wrap: nowrap;
   ${({ margin }) => margin && `margin: ${margin}`};
   align-items: ${({ alignItems = 'center' }) => alignItems};
   width: ${({ width = '100%' }) => width};
`;

export default FlexWrapper;
